<template>
    <canvas :id="id"></canvas>
</template>

<script>
export default {
    props: {
        title: String,
        href: String
    },
    data() {
        return {
            chart: Chart,
            data: null
        }
    },    
    computed: {
        id: function () {
            return this.title.replace(' ', '-').toLowerCase();
        }
    },
    mounted() {
        axios.get(this.href).then(response => {    
            
            this.data = response.data;

            var context = document.getElementById(this.id).getContext('2d');
            
            this.chart = new Chart(context, {
                type: 'bar',
                data: this.data,
                options: {
                    responsive: true,
                    title: {
                        display: true,
                        text: this.title,
                    }
                }                    
            });  
        }); 
    }   
}
</script>

<style scoped>

</style>